<script>
export default {
  inheritAttrs: false,
};
</script>

<template>
  <slot></slot>
</template>
